export const formatQueriesRawData = (rawData) => rawData.map(ele => ({
  id: ele.id,
  queryName: ele.query_name,
  countryId: ele.country_id,
  criteria: ele.criteria,
  countryName: ele.country_name,
  createdAt: ele.created_at,
  updatedAt: ele.updated_at,
  folderName: ele.folder_name,
  folderId: ele.audience_folder_id,
  queryType: ele.query_type
}))




// WEBPACK FOOTER //
// ./src/components/audience-builder/listQueries/helpers.js